import React, { useEffect } from "react";
import CloseIcon from '@mui/icons-material/CloseRounded';
import { Button, Modal, Col, Row } from "react-bootstrap";
import _ from "lodash";
import ApiTransaction from "../../../core/api/api.transaction";

export const ViewModal = ({showModalAgencyTransaction,setShowModalAgencyTransaction,selectedAgencyTransaction}) => {
    const handleClose = () => {
        setShowModalAgencyTransaction(false);
  }
    const [itam, setItem] = React.useState();
    const checkAndShowItem=(item)=>{
        if(item)
        return item;
        else
        return "---";
         }
    useEffect(() => {
        (async () => {
            try {
                if (selectedAgencyTransaction> 0) {
                    // دریافت اطلاعات کاربر جهت ویرایش
                    let response = await ApiTransaction.getTransactionById(selectedAgencyTransaction);
                    if (response.succeeded == true) {
                        setItem(response.data);
                        //setValue("roleList", response.data.roleList);
                    }
                }
            } catch (error) {
                console.log("error :>> ", error);
            }
        })();
        return () => { };
    }, []);

    return (
        <div>
            {/* Start Modal */}
            {/* <Modal centered size='md' show={show} onHide={handleClose}> */}
            <Modal centered size='md' onHide={handleClose} show={showModalAgencyTransaction} >
                <Modal.Header closeButton>
                    <Modal.Title>اطلاعات تراکنش </Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <Col xs='12'>
                        <div className="bg-light rounded shadow-2 py-2">

                            <div className="font-weight-bold text-center pb-2 mb-3">اطلاعات فردی</div>


                            <Col xs="auto">
                                <div className="d-flex align-items-center justify-content-between"> 
                                  <p>  نام و نام خانوادگی  : </p>
                                    <p> {checkAndShowItem(itam?.userFullName)}</p>

                                </div>
                            </Col>
                            <Col xs="auto">    <div className="d-flex align-items-center justify-content-between">

                                <p>       شماره همراه  : </p>
                                <p>       {checkAndShowItem(itam?.phoneNumber)}</p>

                            </div>
                            </Col>
                        </div>
                        <div className="bg-light rounded shadow-2 py-2 mt-2 mt-2">
                            <Col xs='12' >
                                <div className="font-weight-bold text-center pb-2 mb-3">اطلاعات تراکنش</div>
                            </Col>
                            <Col xs="auto">
                                < div className="d-flex align-items-center justify-content-between">

                                    <p>         شماره تراکنش  :</p>
                                    <p>           {checkAndShowItem(itam?.id)}</p>

                                </div>

                            </Col>
                            <Col xs="auto">
                                < div className="d-flex align-items-center justify-content-between">

                                    <p>           مبلغ  :</p>
                                    <p>               {checkAndShowItem(itam?.riallBalance)}</p>

                                </div>

                            </Col>
                            <Col xs="auto">
                                < div className="d-flex align-items-center justify-content-between">

                                    <p>           وضعیت  :</p>
                                    <p>                 {checkAndShowItem(itam?.statusS)}</p>

                                </div>

                            </Col>
                            <Col xs="auto">
                                < div className="d-flex align-items-center justify-content-between">

                                    <p>  تاریخ انجام  : </p>
                                    <p> {checkAndShowItem(itam?.completionDate)}</p>

                                </div>

                            </Col>
                            <Col xs="auto">
                                < div className="d-flex align-items-center justify-content-between">

                                    <p>    زمان انجام   : </p>
                                    <p>  {checkAndShowItem(itam?.completionTime)}</p>

                                </div>

                            </Col>
                            <Col xs="auto">
                                < div className="d-flex align-items-center justify-content-between">

                                    <p>    کد پیگیری  :  </p>
                                    <p>    {checkAndShowItem(itam?.trackingCode)}</p>

                                </div>

                            </Col>
                           
                           {itam?.description && <Col xs="auto">
                                <div className="bg-white rounded p-2 shadow-sm mx-2">
                                    <p className="text-center">           توضیحات  : </p>
                                    <p className="text-center" style={{ wordBreak: "break-all" }}>
                                        {itam?.description}</p>
                                </div>
                            </Col>} 
                        </div>
                        {itam?.userPayment ?
                            <div className="bg-light rounded shadow-2 py-2 mt-2 mt-2">
                                <Col xs='12' >
                                    <div className="font-weight-bold text-center pb-2 mb-3">اطلاعات پرداخت</div>
                                </Col>
                                <Col xs="auto">
                                    < div className="d-flex align-items-center justify-content-between">

                                        <p>      شماره پرداخت  :  </p>
                                        <p>   {checkAndShowItem(itam?.userPayment?.id)}</p>

                                    </div>

                                </Col>
                                {itam.riallBalance !== itam.userPayment.rialAmount &&
                                    <Col xs="auto" >
                                        < div className="d-flex align-items-center justify-content-between">

                                            <p>      مبلغ  :   </p>
                                            <p>     {checkAndShowItem(itam?.userPayment?.rialAmount.toLocaleString())}</p>

                                        </div>

                                    </Col>
                                }
                                {itam.completionDate !== itam.userPayment.paymentDate &&
                                    <Col xs="auto" >
                                        < div className="d-flex align-items-center justify-content-between">

                                            <p>     تاریخ انجام   : </p>
                                            <p>   {checkAndShowItem(itam?.userPayment?.paymentDate)}</p>

                                        </div>

                                    </Col>
                                }
                                {itam.completionTime !== itam.userPayment.paymentTime &&
                                    <Col xs="auto" >
                                        < div className="d-flex align-items-center justify-content-between">

                                            <p>     زمان انجام   :  </p>
                                            <p>    {checkAndShowItem(itam?.userPayment?.paymentTime)}</p>

                                        </div>

                                    </Col>
                                }
                                <Col xs="auto">
                                    < div className="d-flex align-items-center justify-content-between">

                                        <p>         شماره کارت پرداخت  : </p>
                                        <p>     {checkAndShowItem(itam?.userPayment?.cardNumberPayment)}</p>

                                    </div>

                                </Col>
                                <Col xs="auto">
                                    < div className="d-flex align-items-center justify-content-between">

                                        <p>      شماره مرجع (referenceId)  : </p>
                                        <p>    {checkAndShowItem(itam?.userPayment?.referenceId)}</p>

                                    </div>

                                </Col>
                                <Col xs="auto">
                                    < div className="d-flex align-items-center justify-content-between">

                                        <p>       شماره توکن  : </p>
                                        <p>               {checkAndShowItem(itam?.userPayment?.tokenNumber)}</p>

                                    </div>

                                </Col>
                                <Col xs="auto">
                                    < div className="d-flex align-items-center justify-content-between">

                                        <p>         شماره ای پی  : </p>
                                        <p>             {checkAndShowItem(itam?.userPayment?.userIp)}</p>

                                    </div>

                                </Col>
                                {itam.description !== itam.userPayment.description &&
                                    <Col xs="auto" >
                                        <div className="bg-white rounded p-2 shadow-sm mx-2">
                                            <p className="text-center">           توضیحات  : </p>
                                            <p className="text-center" style={{ wordBreak: "break-all" }}>{itam?.userPayment?.description}</p>
                                        </div>
                                    </Col>
                                }
                            </div>
                            : <></>}
                        {itam?.basket ?
                            <div className="bg-light rounded shadow-2 py-2 mt-2 mt-2">
                                <Col xs='12' >
                                    <div className="font-weight-bold text-center pb-2 mb-3">اطلاعات سبد خرید</div>
                                </Col>
                                <Col xs="auto">
                                    < div className="d-flex align-items-center justify-content-between">

                                        <p>             شماره سبد  : </p>
                                        <p>                 {checkAndShowItem(itam?.basket?.id)}</p>

                                    </div>


                                </Col>
                                <Col xs="auto">
                                    < div className="d-flex align-items-center justify-content-between">

                                        <p>             مبلغ اصلی  :</p>
                                        <p>               {checkAndShowItem(itam?.basket?.originalPrice.toLocaleString())}</p>

                                    </div>

                                </Col>
                                <Col xs="auto">
                                    < div className="d-flex align-items-center justify-content-between">

                                        <p>          مبلغ نهایی  :</p>
                                        <p>               {checkAndShowItem(itam?.basket?.price.toLocaleString())}</p>

                                    </div>
                                </Col>
                                {/* <Col xs="auto">
                                    وضعیت سبد  : {itam?.basket?.status}
                                </Col> */}
                            </div>
                            : <></>}
                        {itam?.userWithdrawal ?
                            <div className="bg-light rounded shadow-2 py-2 mt-2">
                                <Col xs='12' >
                                    <div className="font-weight-bold text-center pb-2 mb-3">اطلاعات درخواست برداشت وجه</div>
                                </Col>
                                <Col xs="auto">
                                    < div className="d-flex align-items-center justify-content-between">

                                        <p>          شماره درخواست  :</p>
                                        <p>               {checkAndShowItem(itam?.userWithdrawal?.id)}</p>

                                    </div>

                                </Col>
                                {itam.riallBalance !== itam.userWithdrawal.rialAmount &&
                                    <Col xs="auto" >
                                        < div className="d-flex align-items-center justify-content-between">

                                            <p>        مبلغ  : </p>
                                            <p>            {checkAndShowItem(itam?.userWithdrawal?.rialAmount.toLocaleString())}</p>

                                        </div>

                                    </Col>
                                }
                                {itam.completionDate !== itam.userWithdrawal.paymentDate &&
                                    <Col xs="auto" >
                                        < div className="d-flex align-items-center justify-content-between">

                                            <p>      تاریخ انجام   : </p>
                                            <p>{checkAndShowItem(itam?.userWithdrawal?.paymentDate)}</p>

                                        </div>

                                    </Col>
                                }
                                {itam.completionTime !== itam.userWithdrawal.paymentTime &&
                                    <Col xs="auto" >
                                        < div className="d-flex align-items-center justify-content-between">

                                            <p>    زمان انجام   : </p>
                                            <p>   {checkAndShowItem(itam?.userWithdrawal?.paymentTime)}</p>

                                        </div>

                                    </Col>
                                }
                                {/* <Col xs="auto">
                                    وضعیت درخواست  : {itam?.userWithdrawal?.status}
                                </Col> */}
                                {itam.userWithdrawal.destinationAccount ?
                                    <Row >
                                        <Col xs='12' >

                                            <div className="font-weight-bold text-center pb-2 mb-3">---- اطلاعات حساب مقصد : </div>
                                        </Col>
                                        <Col xs="auto" >
                                            < div className="d-flex align-items-center justify-content-between">

                                                <p>     نام بانک  :  </p>
                                                <p>   {checkAndShowItem(itam.userWithdrawal.destinationAccount.bank)}</p>

                                            </div>

                                        </Col>
                                        <Col xs="auto" >
                                            < div className="d-flex align-items-center justify-content-between">

                                                <p>  نام صاحب حساب  : </p>
                                                <p>  {checkAndShowItem(itam.userWithdrawal.destinationAccount.accountOwnerName)}</p>

                                            </div>

                                        </Col>
                                        <Col xs="auto" >
                                            < div className="d-flex align-items-center justify-content-between">

                                                <p>  شماره حساب  : </p>
                                                <p> {checkAndShowItem(itam.userWithdrawal.destinationAccount.accountNumber)}</p>

                                            </div>


                                        </Col>
                                        <Col xs="auto" >
                                            < div className="d-flex align-items-center justify-content-between">

                                                <p>    نام صاحب کارت  :  </p>
                                                <p>{checkAndShowItem(itam.userWithdrawal.destinationAccount.cardOwnerName)}</p>

                                            </div>

                                        </Col>
                                        <Col xs="auto" >
                                            < div className="d-flex align-items-center justify-content-between">

                                                <p>     شماره کارت  :  </p>
                                                <p>   {checkAndShowItem(itam.userWithdrawal.destinationAccount.cardNumber)}</p>

                                            </div>


                                        </Col>
                                        <Col xs="auto" >
                                            < div className="d-flex align-items-center justify-content-between">

                                                <p>      شماره شبا  :  </p>
                                                <p>   {checkAndShowItem(itam.userWithdrawal.destinationAccount.shebaNumber)}</p>

                                            </div>
                                        
                                        </Col>
                                    </Row>
                                    : <></>}
                            </div>
                            : <></>}
                    </Col>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" onClick={handleClose}>
                        <CloseIcon />  بستن
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}
